module.exports = __webpack_public_path__ + "img/2_3_4.75641b97.png";